export const handleRedirectToContactDetails = (userType, contactId) => {
  if (userType === 'jobSeeker') {
    return ``;
  }
  return `/contacts/${contactId}/parent-profile`;
};

export const disabledDate = (current) => {
  const today = new Date();
  return current && current > today;
};
